export default {
  isLoginModalOpened: state => state.isLoginModalOpened
}
